export const isAdmin = currentUser => {
    if (!currentUser || !Array.isArray(currentUser.userRoles)) return false;
    if (currentUser.userRoles.includes('admin')) return true;
    console.log('here')
    return false;
}